import React from 'react';

const AvatarBlock = ({ image, name, title, subtitle, className = "", onImageClick }) => {
  const imageSrc = image || "https://placehold.co/80x80";
  const isPlaceholder = imageSrc.includes("placehold.co");

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <img
        src={imageSrc}
        alt="Profile"
        className={`rounded-full w-16 h-16 sm:w-20 sm:h-20 object-cover border border-gray-300 ${
          onImageClick && !isPlaceholder ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''
        }`}
        onClick={onImageClick && !isPlaceholder ? () => onImageClick(imageSrc) : undefined}
      />
      <div>
        <div className="text-lg sm:text-xl font-semibold text-black">
          {name || title || "N/A"}
        </div>
        {subtitle && <div className="text-sm text-gray-600">{subtitle}</div>}
      </div>
    </div>
  );
};

export default AvatarBlock;
